// extracted by mini-css-extract-plugin
module.exports = {"item":"MyFollowers_item__1Okbo","list":"MyFollowers_list__35VFj","info":"MyFollowers_info__hDgsJ"};